import { render, staticRenderFns } from "./AtomContentThumbSliderBrochure.vue?vue&type=template&id=6c52735e&"
import script from "./AtomContentThumbSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./AtomContentThumbSliderBrochure.vue?vue&type=script&lang=js&"
import style0 from "./AtomContentThumbSliderBrochure.vue?vue&type=style&index=0&id=6c52735e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports